module.exports = __webpack_public_path__ + "static/img/xiugai.b9c534e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/xiugai.png
// module id = SEWP
// module chunks = 1